import { parseJson } from '@/utils/string';

interface GWSAttributes {
  gws_owner_email?: string;
  gws_owner_display_name?: string;
  gws_shared_drive_name?: string;
  gws_mime_type?: string;
  gws_email_from?: string;
  gws_email_to?: string;
  gws_email_subject?: string;
  gws_email_date?: string;
}

export const parseGWSAttributes = (attributes?: string): GWSAttributes =>
  parseJson<GWSAttributes>(attributes) ?? {};
